module.exports = __webpack_public_path__ + "assets/img/home_right.f389917d.png";